export default __webpack_public_path__ + "static/ICCAM_03-4b2dd0099e2c67ba1ce2e2ee559ad3dd.webp";